import { ApiPostGenerateObjective } from "@/apis/dispatchMission";
import { DispatchDifficultyLevel } from "@/enums/mission";
import i18n from "@/locales";
import { useGlobalModal } from "@/stores/globalModal";
import { useGlobalUser } from "@/stores/globalUser";
import { MateDispatch } from "@/types/entity";
import { showConfirmDialog, showLoadingToast } from "vant";

// 生成简单难度的任务目标
export const generateObjective = async (
  dispatchMission: MateDispatch & { objectiveSignature: string }
) => {
  if (
    useGlobalModal().shouldOpenPowerNotEnoughModal({
      spentPowerAmount: 1,
      cb: () => generateObjective(dispatchMission),
      plusModelRatio: true,
    })
  )
    return;

  const {
    mateId,
    mission,
    location,
    dispatchMemberzz,
    objective,
    carriedJournalzz,
    carriedMailzz,
    carriedDispatchzz,
  } = dispatchMission;
  const loading = showLoadingToast(
    i18n.global.t(
      objective
        ? `Message.difficultyLevelGeneration`
        : `Message.targetGeneration`
    )
  );
  const res = await ApiPostGenerateObjective({
    mateId: mateId!,
    missionId: mission!.id,
    locationId: location!.id,
    objective: objective || "",
    difficultyLevel: DispatchDifficultyLevel.Easy,
    memberIdzz: dispatchMemberzz?.map((v) => v.mate!.id).filter(Boolean),
    carriedJournalIdzz: carriedJournalzz?.map((v) => v.id),
    carriedMailIdzz: carriedMailzz?.map((v) => v.id),
    carriedDispatchIdzz: carriedDispatchzz?.map((v) => v.id),
  });
  const { goalContent, difficultyLevel, reason, signature } = res.data;
  dispatchMission.objective = goalContent;
  dispatchMission.difficultyLevel = difficultyLevel as DispatchDifficultyLevel;
  dispatchMission.difficultyLevelReason = reason;
  dispatchMission.objectiveSignature = signature;
  useGlobalUser().refresh();

  loading.close();
};

export const isSame = (a: Entity[], b: Entity[]) => {
  if (a.length !== b.length) return false;
  const aMap = new Set(a.map((v) => v.id));
  return b.every((v) => aMap.has(v.id));
};

// 当 dispatchMemberzz, objective, location, carriedJournalzz, carriedMailzz, carriedDispatchzz 发生变化时，提示用户是否变更目标，如果确认的话，就初始化目标为空
export const checkAndInitObjective = async (
  dispatchMission: MateDispatch & { objectiveSignature?: string }
) => {
  if (!dispatchMission.difficultyLevel) return true;

  try {
    await showConfirmDialog({
      title: i18n.global.t("Message.tips"),
      message: i18n.global.t("Message.changeObjective"),
      confirmButtonText: i18n.global.t("Buttons.continue"),
      cancelButtonText: i18n.global.t("Buttons.cancel"),
    });

    dispatchMission.objective = "";
    dispatchMission.difficultyLevel = undefined;
    dispatchMission.difficultyLevelReason = undefined;
    dispatchMission.objectiveSignature = undefined;
    return true;
  } catch {
    return false;
  }
};
